// extracted by mini-css-extract-plugin
export default {"container":"drag-file_container__oQOSP","noFile":"drag-file_noFile__4A5YV","setFile":"drag-file_setFile__BeD7W","iconContainer":"drag-file_iconContainer__ELUP+"};